// extracted by mini-css-extract-plugin
module.exports = {"solution":"solution_solution__h7B2W","solutionTitle":"solution_solutionTitle__VLB6f","learnMoreButton":"solution_learnMoreButton__0a6KL"};